
document.querySelectorAll("[data-oak-native-header]").forEach(function(wrapper){
 var button=wrapper.querySelector('button[aria-label="Open menu"]'),header=wrapper.querySelector("header"),desktop=wrapper.querySelector('nav[aria-label="Main navigation"]');
 if(!button||!header||!desktop)return;
 var mobile=document.createElement("nav");mobile.hidden=true;mobile.setAttribute("aria-label","Mobile navigation");mobile.className="border-t border-[#D4D4D4] bg-white px-5 py-5 lg:hidden";var links=document.createElement("div");links.className="grid gap-4 text-base";links.innerHTML=desktop.innerHTML;var basket=document.createElement("a");basket.href=globalThis.WOODSON_URL("/cart");basket.textContent="Basket";links.appendChild(basket);mobile.appendChild(links);header.appendChild(mobile);
 button.addEventListener("click",function(){mobile.hidden=!mobile.hidden;button.setAttribute("aria-expanded",String(!mobile.hidden));button.setAttribute("aria-label",mobile.hidden?"Open menu":"Close menu")});
});
document.querySelectorAll("[data-oak-native-variant]").forEach(function(select){select.addEventListener("change",function(){var price=document.querySelector("[data-oak-native-price]");if(price)price.textContent=select.selectedOptions[0].dataset.price})});

function oakSyncPergolaGroup(rows){
 var parent=rows.find(function(row){return row.dataset.oakParent==="true"});
 if(!parent)return false;
 var input=parent.querySelector('input[name="updates[]"]');
 if(input.value.trim()==="")return false;
 var quantity=Number(input.value);
 if(!Number.isSafeInteger(quantity)||quantity<0)return false;
 rows.forEach(function(row){row.querySelector('input[name="updates[]"]').value=String(quantity)});
 return true;
}
document.querySelectorAll('[data-oak-linked-cart]').forEach(function(form){
 var groups=new Map(),message=form.querySelector('[data-oak-cart-message]');
 form.querySelectorAll('[data-oak-group]').forEach(function(row){
  var key=row.dataset.oakGroup;
  if(!groups.has(key))groups.set(key,[]);
  groups.get(key).push(row);
 });
 groups.forEach(function(rows){
  var parent=rows.find(function(row){return row.dataset.oakParent==="true"});
  if(!parent)return;
  var input=parent.querySelector('input[name="updates[]"]'),remove=parent.querySelector('[data-oak-remove-group]');
  input.readOnly=false;
  input.addEventListener('input',function(){
   if(oakSyncPergolaGroup(rows))message.textContent='Pergola and extras quantities updated. Select Update basket to refresh the total.';
  });
  remove.hidden=false;
  remove.addEventListener('click',function(){
   input.value='0';oakSyncPergolaGroup(rows);
   form.requestSubmit(form.querySelector('button[name="update"]'));
  });
 });
 form.addEventListener('submit',function(event){
  var valid=true;groups.forEach(function(rows){if(!oakSyncPergolaGroup(rows))valid=false});
  if(!valid){event.preventDefault();message.textContent='Enter a whole-number pergola quantity of zero or more.';return}
 });
});
